import { Grid, Paper } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { MemberUpdateActionEnum } from 'src/shared/models/enums/memberUpdateAction.enum';
import { createMemberUpdate } from 'src/shared/services/memberUpdateService';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { MemberUpdateConfirm } from '../components/memberUpdateConfirm';
import { MemberUpdateDataGrid } from '../components/memberUpdateDataGrid';
import { MemberUpdateModal } from '../components/memberUpdateModal';
import { MemberUpdateRequest } from '../models/memberUpdateRequest';

export const MemberUpdates = () => {
  const { t } = useTranslation(['memner']);
  const isMounted = useIsMounted();
  const [loading, setLoading] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [showMemberUpdateModal, setShowMemberUpdateModal] = useState<boolean>(false);
  const [abortMode, setAbortMode] = useState<boolean>(false);
  const [selectedMemberIds, setSelectedMemberIds] = useState<number[]>([]);
  const [selectedMemberUpdateId, setSelectedMemberUpdateId] = useState<number>();

  const handleConfirmClicked = (memberIds: number[], newAbortMode: boolean) => {
    setSelectedMemberIds(memberIds);
    setShowConfirm(true);
    setAbortMode(newAbortMode);
    ConsoleHelper.log('handleConfirmClicked', memberIds, abortMode);
  };

  const handleMemberUpdate = async () => {
    setLoading(true);
    const requestData: MemberUpdateRequest[] = [];
    selectedMemberIds.forEach((item) => {
      requestData.push({
        memberUpdate_id: item,
        action: abortMode ? MemberUpdateActionEnum.Reject : MemberUpdateActionEnum.Accept,
      });
    });
    try {
      await createMemberUpdate(requestData);
      if (isMounted()) {
        toast.success(<>{abortMode ? t('member:memberUpdate.updateRejected') : t('member:memberUpdate.updateSuccess')}</>);
        setSelectedMemberIds([]);
      }
    } catch (e) {
      if (isMounted()) ConsoleHelper.error(e);
    } finally {
      if (isMounted()) setLoading(false);
    }
  };

  const handleReviewClicked = (id: number) => {
    setSelectedMemberUpdateId(id);
    setShowMemberUpdateModal(true);
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs={12}>
          <MainContentHeader title={t('member:memberUpdate.reviewUpdatesHeader')} />
        </Grid>
        <Grid item xs={12}>
          <Paper>
            {!loading && (
              <MemberUpdateDataGrid
                loadingCallback={() => {
                  // setLoading(loadingStatus);
                }}
                reviewClicked={handleReviewClicked}
                confirmClicked={handleConfirmClicked}
                checkboxSelection
              />
            )}
          </Paper>
        </Grid>
      </GridWrapper>
      {showConfirm && selectedMemberIds && !!selectedMemberIds.length && (
        <MemberUpdateConfirm
          callback={() => {
            setShowConfirm(false);
            handleMemberUpdate();
          }}
          onClose={() => {
            setShowConfirm(false);
            setSelectedMemberIds([]);
          }}
          abortMode={abortMode}
        />
      )}
      {selectedMemberUpdateId && (
        <MemberUpdateModal
          modalOpen={showMemberUpdateModal}
          memberUpdateId={selectedMemberUpdateId}
          onSave={() => setShowMemberUpdateModal(false)}
          onClose={() => setShowMemberUpdateModal(false)}
        />
      )}
    </>
  );
};
